import { render, staticRenderFns } from "./FoodDetail.vue?vue&type=template&id=d96f6706&scoped=true&"
import script from "./FoodDetail.vue?vue&type=script&lang=js&"
export * from "./FoodDetail.vue?vue&type=script&lang=js&"
import style0 from "./FoodDetail.vue?vue&type=style&index=0&id=d96f6706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96f6706",
  null
  
)

export default component.exports